import React, { useState, useEffect, useRef } from 'react';
import "./Error.scss";
import { FIELD_MAX_LENGTHS } from '../../../Utils/Constants';
import PasswordTooltip from '../../../../../../Utils/PasswordToolTip/PasswordToolTip';

const PasswordTab = ({ isEditable, passwordData, handleChange, errors }) => {
    const [showPasswords, setShowPasswords] = useState({
        newPassword: false,
        confirmPassword: false
    });

    const [isPasswordFocused, setIsPasswordFocused] = useState(false);
    const passwordWrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (passwordWrapperRef.current && !passwordWrapperRef.current.contains(event.target)) {
                setIsPasswordFocused(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const togglePassword = (field) => {
        setShowPasswords(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const renderPasswordField = (label, name) => {
        const isNewPassword = name === 'newPassword';

        return (
            <div className="cp-split" key={name} style={{ position: 'relative' }}>
                <label className="fi-label">
                    {label} <span>*</span>
                </label>

                <div className={`input-wraper pass-input ${isNewPassword && isPasswordFocused ? 'focused' : ''}`} style={{ position: 'relative' }} ref={isNewPassword ? passwordWrapperRef : null}>
                    {isNewPassword && isPasswordFocused && !passwordData[name] && (
                        <PasswordTooltip />
                    )}

                    <input className={`common-input ${errors[name] ? 'error' : ''}`} type={showPasswords[name] ? 'text' : 'password'} name={name} maxLength={FIELD_MAX_LENGTHS.password}
                        value={passwordData[name]}
                        onChange={handleChange}
                        onFocus={() => isNewPassword && setIsPasswordFocused(true)}
                        onBlur={() => isNewPassword && setIsPasswordFocused(false)}
                    />

                    <i className={`fa field-icon ${showPasswords[name] ? 'fa-eye' : 'fa-eye-slash'}`} onClick={() => togglePassword(name)} style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer' }} />
                </div>

                <span className={`error-text ${errors[name] ? 'active' : ''}`}>
                    {errors[name] || ' '}
                </span>
            </div>
        );
    };

    return (
        <div className="aptab-inner">
            {renderPasswordField('New Password', 'newPassword')}
            {renderPasswordField('Confirm Password', 'confirmPassword')}
        </div>
    );
};

export default PasswordTab;